import { apiService } from './apiService';

// Dashboard reads must never be replayed as offline actions. Keep this wrapper
// separate from the scoring client's durable request behaviour.
export async function dashboardRequest(endpoint, options = {}) {
    const result = await apiService.request(endpoint, {
        method: 'GET',
        ...options,
        skipOfflineQueue: true,
    });
    if (!result || result.success === false) {
        throw new Error(result?.message || 'Could not load the latest dashboard data.');
    }
    return result;
}
